import { render, staticRenderFns } from "./MarketIncomeExpense.vue?vue&type=template&id=5538b49d&scoped=true"
import script from "./MarketIncomeExpense.vue?vue&type=script&lang=js"
export * from "./MarketIncomeExpense.vue?vue&type=script&lang=js"
import style0 from "./MarketIncomeExpense.vue?vue&type=style&index=0&id=5538b49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5538b49d",
  null
  
)

export default component.exports